import { connect } from 'react-redux';

import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { AppState } from '@/types';

import { Stepper as Component } from './Stepper';

const mapStateToProps = (state: AppState) => ({
  submitInProgress: selectRequestStatus(state, 'orders|createDesignToOrder'),
});

const mapActionsToProps = {};

export const Stepper = connect(mapStateToProps, mapActionsToProps)(Component);
